import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type AnimalAge = {
    id: number,
    title: string,
    value: string,
    icon: string 
}

type AnimalAgeDto = {
    title: string,
    value: string,
    icon: string 
}

export const animalAgesApi = createApi({
    reducerPath: 'animalAgesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["ANIMAL-AGE"],
    endpoints: builder => ({
        getAllAnimalAges: builder.query<AnimalAge[], void>({
            query: () => ({ url: `/animal-age` }),
            providesTags: ["ANIMAL-AGE"],
        }),
        getAllAnimalAgesEn: builder.query<AnimalAge[], void>({
            query: () => ({ url: `/animal-age?lang=en` }),
            providesTags: ["ANIMAL-AGE"],
        }),
        getAnimalAge: builder.query<AnimalAge, { id: number }>({
            query: ({ id }) => ({ url: `/animal-age/${id}` }),
            providesTags: ["ANIMAL-AGE"],
        }),
        createAnimalAge: builder.mutation<any, AnimalAgeDto>({
            query: (body) =>({url: `/animal-age`, method: "POST", body: body}),
            invalidatesTags: ["ANIMAL-AGE"],
        }),
        deleteAnimalAgesByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/animal-age/delete/byIds`, method: "POST", body: data}),
            invalidatesTags: ["ANIMAL-AGE"],
        }),
        updateAnimalAges: builder.mutation<any, any>({
            query: data => ({ url: `/animal-age/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["ANIMAL-AGE"],
        }),
        updateAnimalAgeEn: builder.mutation<any, any>({
            query: data => ({
                url: `/animal-age/en/update/${data.id}`,
                method: 'PATCH',
                body: { title: data.title }
            }),
            invalidatesTags: ['ANIMAL-AGE']
        })
    })
})

export const { useGetAllAnimalAgesQuery, useGetAllAnimalAgesEnQuery, useGetAnimalAgeQuery, useCreateAnimalAgeMutation, useDeleteAnimalAgesByIdsMutation, useUpdateAnimalAgesMutation, useUpdateAnimalAgeEnMutation } = animalAgesApi
